module.exports = __webpack_public_path__ + "img/marker.762b6d8a.svg";